import payload_plugin_qLmFnukI99 from "/Users/lysis/Documents/html/esoteric/app_dir/node_modules/@pinia/nuxt/dist/runtime/payload-plugin.js";
import revive_payload_client_4sVQNw7RlN from "/Users/lysis/Documents/html/esoteric/app_dir/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/Users/lysis/Documents/html/esoteric/app_dir/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/Users/lysis/Documents/html/esoteric/app_dir/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import debug_hAQZccAnsC from "/Users/lysis/Documents/html/esoteric/app_dir/node_modules/nuxt/dist/app/plugins/debug.js";
import payload_client_yVLowv6hDl from "/Users/lysis/Documents/html/esoteric/app_dir/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/Users/lysis/Documents/html/esoteric/app_dir/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import chunk_reload_client_UciE0i6zes from "/Users/lysis/Documents/html/esoteric/app_dir/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/Users/lysis/Documents/html/esoteric/app_dir/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/Users/lysis/Documents/html/esoteric/app_dir/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/Users/lysis/Documents/html/esoteric/app_dir/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_tMGwffvjBc from "/Users/lysis/Documents/html/esoteric/app_dir/node_modules/@formkit/auto-animate/nuxt/runtime/plugin.mjs";
export default [
  payload_plugin_qLmFnukI99,
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  debug_hAQZccAnsC,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_tMGwffvjBc
]